/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */
var captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
var validationErrorHandler = function validationErrorHandler(graphQLError) {
  var invalidFragmentMatch = captureRegex.exec(graphQLError.message);
  if (Array.isArray(invalidFragmentMatch)) {
    var invalidFragment = invalidFragmentMatch[1];
    if (invalidFragment) {
      return invalidFragment;
    }
  }
  return null;
};
export default validationErrorHandler;